"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Do not edit this file, it is automatically generated by @paprika/build-translations
var locales = {
    "en": {
        "translation": {
            "page_header": {
                "example": "Example",
                "icons": {
                    "academy": "Academy",
                    "asset_inventory": "Asset Inventory",
                    "assets_and_attributes": "Assets and Attributes",
                    "assurance_plans": "Assurance Plans",
                    "bulk_importer": "Bulk Importer",
                    "compliance_maps": "Compliance Maps",
                    "community": "Community",
                    "frameworks": "Frameworks",
                    "issue_tracker": "Issue Tracker",
                    "launchpad": "Launchpad",
                    "mission_control": "Mission Control",
                    "projects": "Projects",
                    "reports": "Reports",
                    "results": "Results",
                    "robots": "Robots",
                    "scheduler": "Scheduler",
                    "storyboard": "Storyboards",
                    "strategy": "Strategy",
                    "task_tracker": "Task Tracker",
                    "time_sheets": "Timesheets",
                    "toolkits": "Toolkits"
                }
            }
        }
    }
};
exports.default = locales;
//# sourceMappingURL=en.js.map